<div
    class="alert bg-danger-light py-2 border-danger border-start-0 d-flex align-items-center gap-2 flex-wrap rounded-0 mb-0">
    <div class="content d-flex align-items-center gap-2 ">
        <svg *ngIf="buttonShow"
            width="16"
            height="14"
            viewBox="0 0 16 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M7.99984 5.00015V7.66682M7.99984 10.3335H8.00651M7.07672 1.59464L1.59346 11.0657C1.28932 11.591 1.13726 11.8537 1.15973 12.0693C1.17933 12.2573 1.27785 12.4282 1.43075 12.5394C1.60606 12.6668 1.90957 12.6668 2.51658 12.6668H13.4831C14.0901 12.6668 14.3936 12.6668 14.5689 12.5394C14.7218 12.4282 14.8203 12.2573 14.8399 12.0693C14.8624 11.8537 14.7104 11.591 14.4062 11.0657L8.92296 1.59463C8.61991 1.07119 8.46839 0.809471 8.27071 0.721569C8.09827 0.644894 7.90141 0.644894 7.72897 0.721569C7.53129 0.809471 7.37976 1.07119 7.07672 1.59464Z"
                stroke="#D92D20"
                stroke-width="1.3"
                stroke-linecap="round"
                stroke-linejoin="round" />
        </svg>
        <ng-container>
            <span class="text-danger fw-semibold text-sm">{{bannerMessage || ''}}
            </span>
        </ng-container>
        <button type="button"
            *ngIf="buttonShow"
            pmdRipple
            pmd-btn
            pmd-btn-outline
            color="dark"
            class="pmd-btn-min btn-sm ms-md-3 py-2 text-xs"
            (click)="onOpenSubscriptionModal()">Upgrade to Premium</button>
    </div>
</div>